const booking = {
    en: {
        "booking.title": "Booking",

        "booking.buyer": "Buyer",
        "booking.booking": "Booking",
        "booking.line": "Line",
        "booking.container": "Container",
        "booking.deliveryLocation": "Delivery Location",
        "booking.delivery": "Delivery",
        "booking.loadingPort": "Loading Port",
        "booking.containerLoadedDate": "Container Loaded Date",
        "booking.containerReceiveDate": "Container Receive Date",
        "booking.estimatedArrivalDate": "Estimated Arrival Date",
        "booking.terminal": "Terminal",
        "booking.estimatedOpeningDate": "Estimated Opening Date",
        "booking.openingDate": "Opening Date",
        "booking.openDate": "Open Date",
        "booking.loaded": "Loaded",
        "booking.received": "Received",
        "booking.estOpening": "Est. Opening",
        "booking.opening": "Opening",

        "booking.oldToNew": "Old To New",
        "booking.newToOld": "New To Old",
        "booking.filterPort": "Port",
        "booking.selectLine": "Select Line",

        "booking.removeTitle": "Remove booking",
        "booking.removeConfirm": "Do you want to remove booking?",

        "booking.addTitle": "Add New Booking",
        "booking.editTitle": "Modify Booking",
        "booking.buyerFullname": "Buyer Fullname",
        "booking.bookingNumber": "Booking Number",
        "booking.containerReceiver": "Container Receiver",
        "booking.selectLocation": "Select location",
        "booking.selectLoadingPort": "Select loading port",
        "booking.lotStock": "Lot/Stock",
        "booking.markModelYear": "Mark, Model, Year",
        "booking.userId": "User ID",
        "booking.boat": "Boat",
        "booking.selectBoat": "Select Boat",

        "booking.enterVin": "Enter vin code",
        "booking.typeToFilter": "Type to filter",
        "booking.enterBuyer": "Enter buyer",
        "booking.enterBookingNumber": "Enter booking number",
        "booking.enterContainerNumber": "Enter container number",
        "booking.enterReceiver": "Enter receiver",
        "booking.enterTerminal": "Enter terminal",
        "booking.enterLotStock": "Enter lot/stock",
        "booking.enterMarkModelYear": "Enter Mark, Model, Year",
        "booking.enterUserId": "Enter user ID",

        "booking.carsNotFound": "Cars Not Found",
        "booking.containerNotFound": "Container Not Found",
    },
    ru: {
        "booking.title": "Бронирование",

        "booking.buyer": "Покупатель",
        "booking.booking": "Бронирование",
        "booking.line": "Линия",
        "booking.container": "Контейнер",
        "booking.deliveryLocation": "Место доставки",
        "booking.delivery": "Доставка",
        "booking.loadingPort": "Порт погрузки",
        "booking.containerLoadedDate": "Дата погрузки контейнера",
        "booking.containerReceiveDate": "Дата получения контейнера",
        "booking.estimatedArrivalDate": "Ожидаемая дата прибытия",
        "booking.terminal": "Терминал",
        "booking.estimatedOpeningDate": "Ожидаемая дата открытия",
        "booking.openingDate": "Дата открытия",
        "booking.openDate": "Дата открытия",
        "booking.loaded": "Загружено",
        "booking.received": "Получено",
        "booking.estOpening": "Ожид. открытие",
        "booking.opening": "Открытие",

        "booking.oldToNew": "От старых к новым",
        "booking.newToOld": "От новых к старым",
        "booking.filterPort": "Порт",
        "booking.selectLine": "Выберите линию",

        "booking.removeTitle": "Удалить бронирование",
        "booking.removeConfirm": "Вы хотите удалить бронирование?",

        "booking.addTitle": "Добавить бронирование",
        "booking.editTitle": "Редактировать бронирование",
        "booking.buyerFullname": "ФИО покупателя",
        "booking.bookingNumber": "Номер бронирования",
        "booking.containerReceiver": "Получатель контейнера",
        "booking.selectLocation": "Выберите место",
        "booking.selectLoadingPort": "Выберите порт погрузки",
        "booking.lotStock": "Лот/Сток",
        "booking.markModelYear": "Марка, модель, год",
        "booking.userId": "ID пользователя",
        "booking.boat": "Судно",
        "booking.selectBoat": "Выберите судно",

        "booking.enterVin": "Введите vin код",
        "booking.typeToFilter": "Введите для фильтра",
        "booking.enterBuyer": "Введите покупателя",
        "booking.enterBookingNumber": "Введите номер бронирования",
        "booking.enterContainerNumber": "Введите номер контейнера",
        "booking.enterReceiver": "Введите получателя",
        "booking.enterTerminal": "Введите терминал",
        "booking.enterLotStock": "Введите лот/сток",
        "booking.enterMarkModelYear": "Введите марку, модель, год",
        "booking.enterUserId": "Введите ID пользователя",

        "booking.carsNotFound": "Автомобили не найдены",
        "booking.containerNotFound": "Контейнер не найден",
    },
    geo: {
        "booking.title": "ჯავშანი",

        "booking.buyer": "მყიდველი",
        "booking.booking": "ჯავშანი",
        "booking.line": "ხაზი",
        "booking.container": "კონტეინერი",
        "booking.deliveryLocation": "მიწოდების ადგილი",
        "booking.delivery": "მიწოდება",
        "booking.loadingPort": "დატვირთვის პორტი",
        "booking.containerLoadedDate": "კონტეინერის დატვირთვის თარიღი",
        "booking.containerReceiveDate": "კონტეინერის მიღების თარიღი",
        "booking.estimatedArrivalDate": "პორტში სავარაუდო შემოსვლის თარიღი",
        "booking.terminal": "ტერმინალი",
        "booking.estimatedOpeningDate": "სავარაუდო გახსნის თარიღი",
        "booking.openingDate": "გახსნის თარიღი",
        "booking.openDate": "გახსნის თარიღი",
        "booking.loaded": "დატვირთული",
        "booking.received": "მიღებული",
        "booking.estOpening": "სავ. გახსნა",
        "booking.opening": "გახსნა",

        "booking.oldToNew": "ძველიდან ახლისკენ",
        "booking.newToOld": "ახლიდან ძველისკენ",
        "booking.filterPort": "პორტი",
        "booking.selectLine": "აირჩიეთ ხაზი",

        "booking.removeTitle": "ჯავშნის წაშლა",
        "booking.removeConfirm": "გსურთ ჯავშნის წაშლა?",

        "booking.addTitle": "ახალი ჯავშნის დამატება",
        "booking.editTitle": "ჯავშნის რედაქტირება",
        "booking.buyerFullname": "მყიდველის სახელი და გვარი",
        "booking.bookingNumber": "ჯავშნის ნომერი",
        "booking.containerReceiver": "კონტეინერის მიმღები",
        "booking.selectLocation": "აირჩიეთ ადგილი",
        "booking.selectLoadingPort": "აირჩიეთ დატვირთვის პორტი",
        "booking.lotStock": "ლოტი/სტოკი",
        "booking.markModelYear": "მარკა, მოდელი, წელი",
        "booking.userId": "მომხმარებლის ID",
        "booking.boat": "გემი",
        "booking.selectBoat": "აირჩიეთ გემი",

        "booking.enterVin": "შეიყვანეთ vin კოდი",
        "booking.typeToFilter": "აკრიფეთ ფილტრისთვის",
        "booking.enterBuyer": "შეიყვანეთ მყიდველი",
        "booking.enterBookingNumber": "შეიყვანეთ ჯავშნის ნომერი",
        "booking.enterContainerNumber": "შეიყვანეთ კონტეინერის ნომერი",
        "booking.enterReceiver": "შეიყვანეთ მიმღები",
        "booking.enterTerminal": "შეიყვანეთ ტერმინალი",
        "booking.enterLotStock": "შეიყვანეთ ლოტი/სტოკი",
        "booking.enterMarkModelYear": "შეიყვანეთ მარკა, მოდელი, წელი",
        "booking.enterUserId": "შეიყვანეთ მომხმარებლის ID",

        "booking.carsNotFound": "ავტომობილები ვერ მოიძებნა",
        "booking.containerNotFound": "კონტეინერი ვერ მოიძებნა",
    },
};

export default booking;
